import { render, staticRenderFns } from "./MasterDataSupplier.vue?vue&type=template&id=0bf130cd&scoped=true"
import script from "./MasterDataSupplier.vue?vue&type=script&lang=js"
export * from "./MasterDataSupplier.vue?vue&type=script&lang=js"
import style0 from "./MasterDataSupplier.vue?vue&type=style&index=0&id=0bf130cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf130cd",
  null
  
)

export default component.exports